import { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ErrorBoundary from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/routes/guards';
import { DriverRoutes } from '@/routes/driverRoutes';
import { AdminRoutes } from '@/routes/adminRoutes';
import { PortalRoutes } from '@/routes/portalRoutes';
import { CustomerRoutes } from '@/routes/customerRoutes';
import { FleetRoutes } from '@/routes/fleetRoutes';
import { UnifiedRoutes } from '@/routes/unifiedRoutes';

import PrivacyPolicy from '@/pages/public/PrivacyPolicy';
import LegacyUpload from '@/pages/public/LegacyUpload';
import CSDHelp from '@/pages/public/CSDHelp';

export function App() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/privacidad" element={<PrivacyPolicy />} />
          <Route path="/legacy-upload" element={<LegacyUpload />} />
          <Route path="/ayuda/csd" element={<CSDHelp />} />
          <Route path="/driver/login" element={<Navigate to="/app/login" replace />} />
          <Route path="/driver/*" element={<DriverRoutes />} />
          <Route path="/admin/*" element={<AdminRoutes />} />
          <Route path="/portal/login" element={<Navigate to="/app/login" replace />} />
          <Route path="/portal/*" element={<PortalRoutes />} />
          <Route path="/customer/login" element={<Navigate to="/app/login" replace />} />
          <Route path="/customer/*" element={<CustomerRoutes />} />
          <Route path="/fleet/login" element={<Navigate to="/app/login" replace />} />
          <Route path="/fleet/*" element={<FleetRoutes />} />
          <Route path="/app/*" element={<UnifiedRoutes />} />
          <Route path="/" element={<Navigate to="/app/login" replace />} />
          <Route path="*" element={<Navigate to="/app/login" replace />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;
